import React, {useEffect, useState} from 'react';
import {Container, Row} from "react-bootstrap";
import {obtenerArchivos} from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const Cultura = () => {
    const [imagen, setImagen] = useState(null);
    const seccionId = 5;

    useEffect(() => {
        obtenerArchivos({seccionId})
            .then((result) => {
                if (result && result.success) {
                    // Filtrar solo imágenes (opcional si hay otros archivos en la sección)
                    const imagenes = result.archivos.filter(archivo => archivo.tipo_mime.startsWith("image/"));
                    if (imagenes.length > 0) {
                        setImagen(imagenes[0].ruta_archivo); // Tomar la primera imagen encontrada
                    }
                } else {
                    console.error(result.mensaje);
                }
            })
            .catch((error) => {
                console.error("Error al obtener la imagen:", error);
            });
    }, []);

    return (
        <section className={"cultura-cx"}>
            <Container>
                <BotonRegresar/>
                <Row className={"align-items-center"}>
                    <div className={"banner-lineamientos"}>
                        <h1>Cultura</h1>
                    </div>
                    {imagen ? (
                        <img src={imagen} alt="Cultura CX" />
                    ) : (
                        <p>Cargando imagen...</p>
                    )}
                </Row>
            </Container>
        </section>
    );
};
